/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_New_InvestorInputs */

const en_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm new to investing and trading.`)
};

const de_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investieren und Handeln sind neu für mich.`)
};

const pt_br2_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estou começando a investir e fazer operações.`)
};

const tr_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yatırım ve alım satım konusunda yeniyim.`)
};

const zh_cn2_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是投资和交易新手。`)
};

const zh_hk2_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我是投資和交易新手。`)
};

const ko_kr2_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`투자와 거래를 처음 시작합니다.`)
};

const ru_ru2_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я только начинаю инвестировать и торговать.`)
};

const es_419_onboarding_v1_profile_new_investor = /** @type {(inputs: Onboarding_V1_Profile_New_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estoy empezando a invertir y hacer operaciones.`)
};

/**
* | output |
* | --- |
* | "I'm new to investing and trading." |
*
* @param {Onboarding_V1_Profile_New_InvestorInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_new_investor = /** @type {((inputs?: Onboarding_V1_Profile_New_InvestorInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_New_InvestorInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_new_investor(inputs)
	if (locale === "de") return de_onboarding_v1_profile_new_investor(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_new_investor(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_new_investor(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_new_investor(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_new_investor(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_new_investor(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_new_investor(inputs)
	return es_419_onboarding_v1_profile_new_investor(inputs)
});